<div class="section">
  <h2 class="title" i18n="@@renewalRequest" id="idRichiestaRinnovo" >Richiesta di rinnovo</h2>
  <h3 class="subtitle">al <span class="has-text-weight-semibold">{{today | fineValidita | date}}</span></h3>
  <div class="columns">
    <div class="column is-8">
      <p class="notification" i18n="@@selectAndProceed">
        Seleziona le tessere che si vogliono rinnovare fino al <strong>{{today | fineValidita | date}}</strong>, compila i dati della carta e premi
        il pulsante "Procedi al pagamento".<br />
        Il portale non memorizza i dati della carta di credito che sono gestiti da Stripe
      </p>
      <div class="table-wrapper" >
        <table class="table is-striped is-fullwidth">
          <thead>
            <tr>
              <th class="text-center th-checkbox">
                &nbsp;
              </th>
              <th i18n="@@card">
                Tessera
              </th>
              <th i18n="@@name">
                Nome
              </th>
              <th i18n="@@onExpireExpiring" class="is-hidden-mobile" >
                &nbsp;
              </th>
              <th i18n="@@fees" class="is-hidden-mobile">
                Tariffa
              </th>
              <th i18n="@@amount">
                Importo
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let socio of soci">
              <td class="text-center td-checkbox">
                <input class="is-checkradio" id="'checkRadio1' + {{socio.id}}" type="checkbox"
                  name="'checkRadio1' + {{socio.id}}" [ngModel]="socio.checked" [disabled]="!socio.valido"
                  (change)="setCheckBeneficiario($event, socio, 1)">
                <label for="'checkRadio1' + {{socio.id}}"></label>
              </td>
              <td>
                {{socio.idTessera && socio.idTessera > 0 ? socio.idTessera : 'N/A'}}
              </td>
              <td>
                {{socio.nomeCompleto | uppercase}}
                <div class="subtitle is-7">
                  <ng-container *ngIf="socio.natoIl; else noData">
                    {{socio.natoIl | date}}
                  </ng-container>
                  <ng-template #noData>
                    N/A
                  </ng-template>
                </div>
              </td>
              <td class="is-hidden-mobile">
                <ng-container *ngIf="socio.fineValidita; else noValidita">
                  {{socio.fineValidita | date}}
                </ng-container>
                <ng-template #noValidita>
                  N/A
                </ng-template>
              </td>
              <td class="is-hidden-mobile">
                {{socio | tipoSocio | titlecase}}
                <div class="subtitle is-7" *ngIf="socio.nomeAssociazione">
                  {{socio.nomeAssociazione}}
                </div>
              </td>
              <!--<td class="is-hidden-touch is-hidden-desktop-only">{{socio.nomeAssociazione}}</td>-->
              <td>{{socio.importo | currency:'EUR'}}</td>
            </tr>
            <tr *ngFor="let amicoFedele of amiciFedeli">
              <td class="td-checkbox">
                <input class="is-checkradio" id="'checkRadio2' + {{amicoFedele.id}}" type="checkbox"
                  name="'checkRadio2' + {{amicoFedele.id}}" [ngModel]="amicoFedele.checked"
                  [disabled]="!amicoFedele.valido" (change)="setCheckBeneficiario($event, amicoFedele, 2)">
                <label for="'checkRadio2' + {{amicoFedele.id}}"></label>
              </td>
              <td>
                <!--{{amicoFedele.id}}-->
                &nbsp;
              </td>
              <td>
                {{amicoFedele.nome | uppercase}}
                <div class="subtitle is-7">
                  {{amicoFedele.chip}}
                </div>
              </td>
              <td class="is-hidden-mobile">
                <ng-container *ngIf="amicoFedele.fineValidita; else noValidita">
                  {{amicoFedele.fineValidita | date}}
                </ng-container>
                <ng-template #noValidita>
                  N/A
                </ng-template>
              </td>
              <td class="is-hidden-mobile">Amico fedele</td>
              <!--<td class="is-hidden-touch is-hidden-desktop-only"></td>-->
              <td>{{amicoFedele.importo | currency:'EUR'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="column is-4">
      <div class="box fix-horizontal-form">
        <div class="is-flex is-justify-content-flex-end">
          <figure class="image" style="width: 100%; max-width: 150px; height:100%; max-height: 64px;" >
            <a href="https://stripe.com/" target="_blank">
              <img src="assets/powered_by_strype.svg">
            </a>
            
          </figure>
        </div>
        
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@amount">Importo</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input is-static" [ngModel]="pagamento.importo | currency:'EUR' " readonly
                  name="importoField" type="text">
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@contribution">Contributo</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <p-spinner [min]="0" [inputStyleClass]="'input'" [(ngModel)]="pagamento.contributo"></p-spinner>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label" i18n="@@total">Totale</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <ng-container *ngIf="pagamento.contributo; else noContributo">
                  <input class="input is-static" readonly name="totaleField"
                    value="{{(pagamento.importo + pagamento.contributo) | currency:'EUR' }}" type="text">
                </ng-container>
                <ng-template #noContributo>
                  <input class="input is-static" readonly name="totaleField"
                    value="{{pagamento.importo | currency:'EUR' }}" type="text">
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal is-align-items-center">
          <div class="field-label is-normal">
            <label i18n="@@cardNumber" class="label">Card</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control fake-input" [ngClass]="{'is-danger' : cardNumberInvalid}">
                <div style="width: 100%; margin-right: 30px;" id="card-number-element"></div>
                <span class="brand"><i [ngClass]="cardClassIcon" style="font-size: 1.8rem;" id="brand-icon"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@expire" class="label">Expire</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control fake-input" [ngClass]="{'is-danger' : expireInvalid}">
                <div style="width: 100%;"  id="card-expiry-element"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label i18n="@@cvc" class="label">CVC</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control fake-input" [ngClass]="{'is-danger' : cvcInvalid}">
                <div style="width: 100%;"  id="card-cvc-element"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <button type="button" [disabled]="!pagamento.importo || pagamentoLoading || cardInvalid" (click)="savePagamento()"
              class="button is-primary is-uppercase is-fullwidth has-text-weight-semibold"
              [class.is-loading]="pagamentoLoading">
              <span i18n="@@proceedToPayament">Procedi</span>
              <span class="icon is-small">
                <i class="fas fa-euro-sign"></i>
              </span>
            </button>
          </div>
          <p class="help is-danger">{{errorPayment}}</p>
        </div>
        
      </div>
    </div>
  </div>
</div>